/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const DeliveryFeeSettingPage = lazyLoad(
  () => import('./index'),
  module => module.DeliveryFeeSettingPage
);
